module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_9005.07c735dd.png";